import { render, staticRenderFns } from "./UpdateEduRecords.vue?vue&type=template&id=64cbf624"
import script from "./UpdateEduRecords.vue?vue&type=script&lang=js"
export * from "./UpdateEduRecords.vue?vue&type=script&lang=js"
import style0 from "./UpdateEduRecords.vue?vue&type=style&index=0&id=64cbf624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports